import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './NavigationTabLink.module.scss';

function NavigationTabLink({ match, disabled, ...otherProps }) {
  const classes = classNames(
    'body14',
    styles.tabLink,
    disabled && styles['tabLink--disabled'],
  );

  return (
    <NavLink
      disabled={disabled}
      className={({ isActive }) =>
        `${classes} ${isActive ? styles['tabLink--active'] : ''}`
      }
      {...otherProps}
    />
  );
}

NavigationTabLink.propTypes = {
  disabled: PropTypes.bool,
  layout: PropTypes.string,
  className: PropTypes.string,
  ...NavLink.propTypes,
  isActive: PropTypes.bool,
  to: PropTypes.string,
};

NavigationTabLink.defaultProps = {
  to: '#',
};

export default memo(NavigationTabLink);
